import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCheckCircle, IconCopy } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useProductCopyVoucherButtonControls } from './useProductCopyVoucherButtonControls'

type ProductCopyVoucherButtonProps = { disabled?: boolean; voucher: string }

export const ProductCopyVoucherButton: FC<ProductCopyVoucherButtonProps> = ({
  disabled,
  voucher,
}) => {
  const { copyVoucher, feedbackState } = useProductCopyVoucherButtonControls({
    voucher,
  })

  return (
    <Button
      className={clsx(
        'border-dark-primary-strong/65 flex w-full max-w-72 whitespace-normal rounded-l border border-dashed bg-light-primary-medium text-dark-primary-max hover:bg-light-hover-primary-medium active:bg-light-pressed-primary-medium disabled:bg-light-primary-high disabled:text-dark-primary-strong',
        feedbackState === 'copySuccess' &&
          'cursor-default !bg-light-primary-medium',
      )}
      data-qa-id="product-copy-voucher-button"
      disabled={disabled}
      endIcon={
        feedbackState === 'idle' && (
          <IconCopy
            aria-hidden
            className={clsx(
              'text-dark-brand hover:text-dark-hover-brand active:text-dark-pressed-brand',
              disabled &&
                'text-dark-primary-strong hover:text-dark-primary-strong',
            )}
          />
        )
      }
      onClick={copyVoucher}
    >
      {feedbackState === 'idle' && (
        <span className="flex-1 break-all p-3 text-start">{voucher}</span>
      )}
      {feedbackState === 'copySuccess' && (
        <div className="flex gap-1">
          <span className="text-center text-dark-success">
            <FormattedMessage id="product.voucher.copySuccess" />
          </span>
          <IconCheckCircle aria-hidden className="size-6 text-dark-success" />
        </div>
      )}
    </Button>
  )
}
